import { render } from "./GameMap.vue?vue&type=template&id=9a5c99f0&scoped=true"
import script from "./GameMap.vue?vue&type=script&lang=js"
export * from "./GameMap.vue?vue&type=script&lang=js"

import "./GameMap.vue?vue&type=style&index=0&id=9a5c99f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5c99f0"]])

export default __exports__